import { Store } from 'redux';
import { useSettingsStore } from '../..';

export function useAppStore(): Store {
  const context = useSettingsStore();

  const store = context.state.settings.store;

  if (!store) {
    throw new Error('App store not found');
  }

  return store;
}
